import type { Tool } from '../types'

export function newTool(number: number, operationType: 'milling' | 'turning' = 'milling'): Tool {
  return {
    id: crypto.randomUUID(),
    number,
    type: operationType === 'turning' ? 'OD Insert' : 'Endmill',
    diameter: 0,
    stickout: 0,
    flutes: 0,
    canPlunge: false,
    description: '',
  }
}
